import React from 'react';

import {getPossibleValuesOrDefault} from 'src/utils/getPossibleValuesOrDefault';

type Props = {
    possibleValues: string[],
};

export const PossibleValues = ({possibleValues}: Props) =>
    <span>{getPossibleValuesOrDefault(possibleValues)}</span>;
